<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 54 54"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="27" cy="27" :fill="fill" r="27"/>
    <g clip-path="url(#clip0)">
      <path clip-rule="evenodd" d="M15.9741 12.825C15.9741 11.9552 16.6793 11.25 17.5491 11.25H20.6991C21.569 11.25 22.2741 11.9552 22.2741 12.825V13.5H31.7241V12.825C31.7241 11.9552 32.4293 11.25 33.2991 11.25H36.4491C37.319 11.25 38.0241 11.9552 38.0241 12.825V13.5H41.175C42.0448 13.5 42.75 14.2052 42.75 15.075V41.175C42.75 42.0448 42.0448 42.75 41.175 42.75H12.825C11.9552 42.75 11.25 42.0448 11.25 41.175V24.75V15.75V15.075C11.25 14.2052 11.9552 13.5 12.825 13.5H15.9741V12.825ZM13.5 40.5V24.75H40.5V40.5H13.5Z" fill="white" fill-rule="evenodd"/>
      <rect fill="white" height="4.5" rx="2.25" width="4.5" x="24.75" y="33.75"/>
      <rect fill="white" height="4.5" rx="2.25" width="4.5" x="24.75" y="27"/>
      <rect fill="white" height="4.5" rx="2.25" width="4.5" x="18" y="33.75"/>
      <rect fill="white" height="4.5" rx="2.25" width="4.5" x="31.5" y="33.75"/>
      <rect fill="white" height="4.5" rx="2.25" width="4.5" x="31.5" y="27"/>
      <rect :fill="fill" height="4.725" width="3.15" x="17.5496" y="12.8254"/>
      <rect :fill="fill" height="4.725" width="3.15" x="33.2996" y="12.8254"/>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect fill="white" height="31.5" transform="translate(11.25 11.25)" width="31.5"/>
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'CalendarCircle',
  props: {
    width: {
      type: String,
      required: false,
      default: '16'
    },
    height: {
      type: String,
      required: false,
      default: '16'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#1D72ED'
    },
  },
};
</script>
